// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3EH7q","upload":"Small_upload__10hC0","imageWrap":"Small_imageWrap__2DtIz","removeBtn":"Small_removeBtn__2e-Rm"};